module.exports = __webpack_public_path__ + "img/AccentEncore.5259baed.svg";